import { useBulkUpdateTaskDetailsMutation } from 'api/taskApi';
import { EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TaskAttributes } from 'types/api/tasks';
import { Button } from 'ui/components';
import { getSelectedSiteInfo } from '../../../../store/siteInfoSlice';
import { getUser, setShowLockFeature } from '../../../../store/userSlice';

interface MakeInternalButtonProps {
    taskId: string;
    task?: Partial<TaskAttributes>
}

export default function MakeInternalButton({
    taskId,
    task,
}: MakeInternalButtonProps): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(getUser);
    const siteInfo = useSelector(getSelectedSiteInfo);
    const [bulkUpdateTaskDetails, { isLoading }] =
        useBulkUpdateTaskDetailsMutation();

    const disabled = !user?.raw?.plan?.internal_tasks;

    const handleClick = async (): Promise<void> => {
        if (isLoading || !taskId || !task || !siteInfo) return;
        if (disabled) {
            dispatch(setShowLockFeature({
                showLockFeature: true,
                lockTitle: 'Internal Task',
                lockParagraph: 'Collaborate privately with your team on tasks hidden from stakeholders. Keep internal discussions organized and focused. Available on Starter, Expert, and Agency plans.',
                lockImg: "https://wpfeedback-image.s3.us-east-2.amazonaws.com/images/integration-lock-images/lock-user-image-3.jpg",
                rank: 3,
            }));
            return
        }
        try {
            await bulkUpdateTaskDetails({
                websiteId: siteInfo.id,
                taskId,
                internal: 1,
            }).unwrap();
            // toast.success(t('task.internal.success', 'Task made internal'));
        } catch (error) {
            console.error('Failed to make task internal:', error);
            // toast.error(t('task.internal.error', 'Failed to make task internal'));
        }
    };


    return (
        <Button
            data-testid="PostInternal InboxInternal"
            variant="outline"
            size="icon"
            onClick={handleClick}
            loading={isLoading}
            disabled={disabled}
            tooltipSide="top"
            tooltip={disabled
                ? t('task.internal.tooltip.unavailable', 'This feature is not available for your plan')
                : t('task.internal.tooltip.description', 'Switch this task to internal, only Admins and Contributors will be able to see')
            }
        >
            <EyeOff size={18} />
        </Button>
    );
}